var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-statistics"},_vm._l((_vm.title),function(data){return _c('div',{key:data.title,staticClass:"list-template"},[_c('p',[_vm._v(_vm._s(data.title))]),_c('p',{domProps:{"textContent":_vm._s(data.content)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }